export const doesOrganizationNameMatchDefault = (organizationName, userFirstName) => organizationName === `${userFirstName}'s Organization`;
